<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('edit')}} {{t('user')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/masters/company-users" class="d-inline-block position-relative">
                    {{t('Company Users')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('edit')}} {{t('user')}}
            </li>
        </ol>
    </div>

    <!-- Edit Company User -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <ng-container *ngIf="editCompanyUser">
                <form [formGroup]="editCompanyUserForm">
                    <div class="row">
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('email-adress')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-email-address')}}
                                    </mat-label>
                                    <input matInput type="text" formControlName="email"
                                        [(ngModel)]="editCompanyUser.email" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('password')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-your-password')}}
                                    </mat-label>
                                    <input matInput [type]="hide ? 'password' : 'text'" formControlName="password">
                                    <button mat-icon-button matSuffix (click)="hide = !hide"
                                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                        <span class="material-symbols-outlined">
                                            {{hide ? 'visibility_off' : 'visibility'}}
                                        </span>
                                    </button>
                                </mat-form-field>
                                <div *ngIf="editCompanyUserForm.get('password')!.dirty || editCompanyUserForm.get('password')!.touched"
                                    class="error text-danger">
                                    <div *ngIf="editCompanyUserForm.get('password')!.hasError('pattern')">
                                        {{t('pattern-password')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('confirm-password')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('confirm-password')}}
                                    </mat-label>
                                    <input matInput [type]="hide2 ? 'password' : 'text'"
                                        formControlName="confirmPassword">
                                    <button mat-icon-button matSuffix (click)="hide2 = !hide2"
                                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
                                        <span class="material-symbols-outlined">
                                            {{hide2 ? 'visibility_off' : 'visibility'}}
                                        </span>
                                    </button>
                                </mat-form-field>
                                <div *ngIf="editCompanyUserForm.get('confirmPassword')!.dirty || editCompanyUserForm.get('confirmPassword')!.touched"
                                    class="error text-danger">
                                    <div *ngIf="editCompanyUserForm.get('confirmPassword')!.hasError('pattern')">
                                        {{t('pattern-password')}}
                                    </div>
                                    <div
                                        *ngIf="editCompanyUserForm.get('confirmPassword')!.hasError('confirmedValidator')">
                                        {{t('passwords-did-not-match')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('name')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-name')}}
                                    </mat-label>
                                    <input matInput type="text" formControlName="name"
                                        [(ngModel)]="editCompanyUser.name" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('role')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-role')}}
                                    </mat-label>
                                    <mat-select formControlName="role" [(value)]="selectedRole" required>
                                        <mat-option *ngFor="let role of roles" [value]="role">
                                            {{role.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('company')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-company')}}
                                    </mat-label>
                                    <mat-select [(value)]="selectedCompany"
                                        (selectionChange)="changeCompany(selectedCompany)">
                                        <mat-option *ngFor="let company of companies" [value]="company.id">
                                            {{company.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('branch-office')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-branch-office')}}
                                    </mat-label>
                                    <mat-select formControlName="branchOffice" [(value)]="selectedBranchOffice"
                                        required>
                                        <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice">
                                            {{branchOffice.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="btn-box">
                        <button mat-flat-button class="altair" (click)="toggleClass()">
                            {{t('add')}} {{t('contact')}}
                        </button>
                        <button mat-flat-button color="warn" [disabled]="!contactInfos.length"
                            (click)="removeSelectedRows()">
                            {{t('remove')}} {{t('contacts')}}
                        </button>
                    </div>

                    <!-- Table -->
                    <div class="row">
                        <table mat-table [dataSource]="dataSource">
                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- Contact Medium Type Column -->
                            <ng-container matColumnDef="contactMediumName">
                                <th mat-header-cell *matHeaderCellDef>{{t('contact-medium-type')}}</th>
                                <td mat-cell *matCellDef="let element">{{element.contactMediumType.name}}</td>
                            </ng-container>
                            <!-- Contact Column -->
                            <ng-container matColumnDef="contact">
                                <th mat-header-cell *matHeaderCellDef>{{t('contact')}}</th>
                                <td mat-cell *matCellDef="let element">{{element.contact}}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                (click)="selection.toggle(row)"></tr>
                        </table>
                    </div>



                    <div class="btn-box">
                        <button mat-button type="button" (click)="onSubmit()" [disabled]="editCompanyUserForm.invalid">
                            {{t('save')}} {{t('user')}}
                        </button>
                        <a mat-button routerLink="/masters/company-users">
                            {{t('cancel')}}
                        </a>
                    </div>
                </form>
            </ng-container>
        </mat-card-content>
    </mat-card>

    <!-- Popup -->
    <div class="add-new-contact-popup" [class.active]="classApplied" [class.rtl-enabled]="themeService.isRTLEnabled()">
        <div class="popup-dialog">
            <mat-card class="altair-card mb-25 border-radius bg-white border-none d-block">
                <mat-card-header>
                    <mat-card-title>
                        <h5 class="mt-0 mb-0">
                            {{t('add')}} {{t('contact')}}
                        </h5>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <button mat-button (click)="toggleClass()">
                            <i class="ri-close-fill"></i>
                        </button>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="addContactForm">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('contact-medium-type')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-contact-medium-type')}}
                                    </mat-label>
                                    <mat-select name="contactMediumType" [(value)]="selectedContactMediumType" required>
                                        <mat-option *ngFor="let contactMediumType of contactMediumTypes"
                                            [value]="contactMediumType">
                                            {{contactMediumType.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('contact')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-contact')}}
                                    </mat-label>
                                    <input matInput formControlName="contact" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="btn-box">
                            <button mat-button (click)="toggleClass()">
                                {{t('cancel')}}
                            </button>
                            <button mat-button type="button" (click)="addContactInfo()"
                                [disabled]="addContactForm.invalid || selectedContactMediumType === undefined">
                                {{t('add')}} {{t('contact')}}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</ng-container>
